import BookPage from "./bookPage";

export default BookPage;
